import React from 'react'
import { Button, Badge } from 'react-bootstrap'

const getSignalBars = (signal) => {
    const bars = [signal > 0, signal > 25, signal > 50, signal > 75]
    return (
        <span className='d-inline-flex align-items-end gap-1' style={{ height: 20 }}>
            {bars.map((active, i) => (
                <span
                    key={i}
                    style={{
                        width: 4,
                        height: 5 + i * 5,
                        backgroundColor: active ? '#50cd89' : '#3f4254',
                        borderRadius: 1,
                        display: 'inline-block',
                    }}
                />
            ))}
        </span>
    )
}

const NetworkRow = ({ network, onConnect, onDisconnect }) => {
    return (
        <tr>
            <td>
                <div className='d-flex align-items-center'>
                    <i className={`bi bi-wifi fs-4 me-3 ${network.in_use ? 'text-success' : 'text-muted'}`} />
                    <span className='fw-bold'>{network.ssid}</span>
                </div>
            </td>
            <td className='text-center'>
                <div className='d-flex align-items-center justify-content-center gap-2'>
                    {getSignalBars(network.signal)}
                    <span className='text-muted fs-7'>{network.signal}%</span>
                </div>
            </td>
            <td className='text-center'>
                <Badge bg={network.security && network.security !== '--' ? 'light-warning' : 'light-info'} className='text-dark'>
                    {network.security || 'Open'}
                </Badge>
            </td>
            <td className='text-center'>
                {network.in_use ? (
                    <Badge bg='success'>Connected</Badge>
                ) : (
                    <span className='text-muted fs-7'>--</span>
                )}
            </td>
            <td className='text-end'>
                {network.in_use ? (
                    <Button variant='outline-danger' size='sm' onClick={() => onDisconnect(network.ssid)}>
                        Disconnect
                    </Button>
                ) : (
                    <Button variant='outline-primary' size='sm' onClick={() => onConnect(network.ssid)}>
                        Connect
                    </Button>
                )}
            </td>
        </tr>
    )
}

export { NetworkRow, getSignalBars }
